export default __webpack_public_path__ + "static/media/customer.00d23518.png";